/* eslint react/prop-types: 0 */
import React from 'react';
import Svg from 'rp-react-svg-icon';
import Abbr from '../../shared/Abbr';
import RatioCell from '../../shared/cells/RatioCell';
import { formatMoney } from '../../utils/money';

const columns = [
    {
        key: 'arrow',
        header: ' ',
        cell: () =>
            <Svg
                className="hp-progeny-statistics__arrow tableShowIcon"
                iconName="down"
                size="Medium"
            />,

    },
    {
        key: 'category',
        header: 'race type',
    },
    {
        key: 'winners',
        header: () => (
            <Abbr title="winners / runners" breakpoint="fromMedium">
                wnrs&nbsp;/ rnrs
            </Abbr>
        ),
        cell: ({ winners: a, runners: b }) => <RatioCell a={a} b={b} />,
    },
    {
        key: 'percentWinnersRunners',
        header: '%',
    },
    {
        key: 'wins',
        header: () => <Abbr title="wins" breakpoint="fromMedium">wins&nbsp;/ runs</Abbr>,
        cell: ({ wins, runs }) => (
            <span>
                <strong>{wins}</strong>
                <span className="hidden-md-up">/<wbr />{runs}</span>
            </span>
        ),
    },
    {
        key: 'runs',
    },
    {
        key: 'percentWinsRuns',
        header: '%',
    },
    {
        key: 'place2ndNumber',
        header: '2nd',
    },
    {
        key: 'place3rdNumber',
        header: '3rd',
    },
    {
        key: 'totalPrizeMoney',
        header: 'total earnings',
        cell: ({ totalPrizeMoney }) => formatMoney(totalPrizeMoney),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/horse/progenyStatistics/columns.jsx